import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/workOrderTemplatesActions'
import * as api from '../../api/template'

function* getWorkOrderTemplates(action) {
  try {
    const payload = yield call(api.getWorkOrderTemplatesList)
    yield put({ type: constants.GET_WORK_ORDER_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_WORK_ORDER_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetWorkOrderTemplates() {
  yield takeLatest(constants.GET_WORK_ORDER_TEMPLATES.ACTION, getWorkOrderTemplates)
}

function* getWorkOrderTemplateItems(action) {
  try {
    const payload = yield call(api.getWorkOrderTemplatesItems, action.workOrderId)
    yield put({ type: constants.GET_WORK_ORDER_TEMPLATE_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_WORK_ORDER_TEMPLATE_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTemplateItems() {
  yield takeLatest(constants.GET_WORK_ORDER_TEMPLATE_ITEMS.ACTION, getWorkOrderTemplateItems)
}

export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchGetWorkOrderTemplates), fork(watchGetTemplateItems)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/workOrderTemplateSaga.js